/// <amd-module name="Wiki/PageTree/WikiTreeHeaderBreadcrumbService" />
import { onClickFPS } from "VSS/Platform/FPS";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";
import { Services, VssService } from "VSS/Platform/Context";
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { ITreeItemEx } from "VSSUI/Utilities/TreeItemProvider";
import { FilteredWikiPage, WikiTreePage } from "./Contracts";

export class WikiTreeHeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setBreadcrumbs(treeItem: ITreeItemEx<WikiTreePage | FilteredWikiPage>) {
        this.items.removeAll();

        let i: number = 1;
        const breadcrumbItems: Array<IBreadcrumbItem> = [];
        let item: ITreeItemEx<WikiTreePage | FilteredWikiPage> | undefined = treeItem;
        while (item !== undefined) {
            let current = item.underlyingItem.data;
            breadcrumbItems.push({
                key: `wiki-subtree-breadcrumb-${i}`,
                text: current.pageName,
                href: current.remoteUrl,
                onClick: (ev) => {
                    onClickFPS(this.pageContext, current.remoteUrl, true, ev, { telemetrySource: `wiki-subtree-breadcrumb-${i}` });
                }
            });

            item = item.parentItem;
            i++;
        }

        this.items.value = breadcrumbItems.reverse();
    }
}

Services.add("wikitree-header-breadcrumb-service", { serviceFactory: WikiTreeHeaderBreadcrumbService });